import { useState, useCallback } from 'react';
import ExportAPI from 'services/API/ExportAPI';
import { FilterViewEnum } from 'types/FilterProjects';

type Props = {
  id: string;
  company?: string;
  companyId?: string;
  activeTabs?: FilterViewEnum[];
};

export const useProjectCsvExport = ({ id, company, companyId, activeTabs }: Props) => {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await ExportAPI.postProjectCsvExport({
        groupConfigId: id,
        company,
        companyId,
        activeTabs,
      });
      const url = response?.data?.url;
      setData(url);
      if (url) {
        window.open(url, '_blank');
      }
      setLoading(false);
    } catch (err: any) {
      setError(err);
      setLoading(false);
    }
  }, [id, company, companyId, activeTabs]);

  return { data, loading, error, fetchData };
};
